import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterLink } from '@angular/router';
import { BackgroundJobTrackerService, TrackedRunState } from '../shared/background-job-tracker.service';

@Component({
  selector: 'app-jobs-panel',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    RouterLink
  ],
  templateUrl: './jobs-panel.component.html',
  styleUrl: './jobs-panel.component.scss'
})
export class JobsPanelComponent {
  private readonly tracker = inject(BackgroundJobTrackerService);
  @Input() roleSlug?: string;

  get runs(): TrackedRunState[] {
    return this.tracker.visibleRuns(this.roleSlug);
  }

  statusColor(status: string | undefined): string {
    switch (status) {
      case 'completed':
        return '#15803d';
      case 'failed':
        return '#b91c1c';
      case 'in_progress':
        return '#1d4ed8';
      default:
        return '#7c3aed';
    }
  }

  dismiss(runId: string): void {
    this.tracker.dismiss(runId);
  }

  latestMessage(run: TrackedRunState): string {
    const history = run.run?.history;
    if (!history?.length) {
      return '';
    }
    return history[history.length - 1].message;
  }
}